import React, { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { StyledButton1 } from '../../Common/Buttons/StyledButtons';
import Center from '../../Common/Layouts/Center';
import { themeColor } from '../../Theming';
import colors from '../../Theming/colors';
import images from '../../Theming/images';

const Container = styled.div`
  width: 100%;
  font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    'Roboto', 'Palanquin', 'Oxygen', 'Ubuntu', 'Cantarell', 'Droid Sans',
    'Helvetica Neue', sans-serif;

  ol {
    padding: 0;
    padding-left: 1rem;
  }
  ol > li {
    padding-bottom: 0.8rem;
    font-size: small;
  }
  img {
    flex: 1;
    object-fit: cover;
    margin-left: 0.2rem;
  }
  h6 {
    margin: 0.5rem 0;
    padding: 0;
  }
  h4 {
    color: ${themeColor('green')};
  }
`;

const WhatYouNeedText = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: Bold;
  line-height: 35px;
  margin-bottom: 11px;
  text-align: center;
  margin-top: 52px;
  width: 100%;
`;

const BodyContentContainer = styled.div`
  width: 100%;
`;

const DisclaimerSubText = styled.p`
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  width: 334px;
`;

const DisclaimerSubTextContainer = styled.div`
  width: 100%;
  margin-bottom: 124px;
  margin-top: -2px;
  display: flex;
  justify-content: center;
`;

const StyledImage = styled.img`
  width: 91.813px;
  height: 91.311px;
`;

const StyledImageContainer = styled.div`
  margin-top: 55px;
`;

const StyledButtonContainer = styled.div`
  width: 100%;
  position: fixed;
  bottom: -10px;
  left: 50%;
  padding-left: 34px;
  padding-right: 34px;
  transform: translateX(-50%);
  max-width: 400px;
`;

const DescriptionWithBrowserNotSupported: React.FC = () => {
  const { t } = useTranslation();

  const copyToClipboard = async () => {
    const alertMessage = t('PartnerpluginsdkActivate.linkCopied');
    try {
      navigator.clipboard.writeText(window.location.href).then(() => {
        alert(alertMessage);
      });
    } catch {
      // fallback for unsupported browsers
      const tempInput = document.createElement('textarea');
      tempInput.value = window.location.href;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      alert(alertMessage);
    }
  };

  return (
    <Container id="browser_not_supported_description_container">
      <BodyContentContainer>
        <WhatYouNeedText>
          <Trans t={t} i18nKey={'PartnerpluginsdkActivate.openInSafari'} />
        </WhatYouNeedText>
      </BodyContentContainer>
      <Center flexDirection="column" marginTop={-20}>
        <StyledImageContainer id="safari_logo_container">
          <StyledImage
            id="safari_logo_container"
            src={images.safari_browser_logo?.default}
            alt="safari_logo"
          />
        </StyledImageContainer>
        <DisclaimerSubTextContainer id="browser_not_supported_container">
          <DisclaimerSubText id="browser_not_supported_paragraph">
            {t('PartnerpluginsdkActivate.iOSExtensionOnlyWorksOn')}
          </DisclaimerSubText>
        </DisclaimerSubTextContainer>
        <StyledButtonContainer id="copy_link_button_container">
          <StyledButton1
            onClick={copyToClipboard}
            borderRadius="4px"
            boxShadow="none !important;"
            width="100%"
            fontFamily="'Fira Sans' !important;"
            backgroundColor={colors.semiDarkGrey}
            color={colors.white}
            fontSize={20}
            padding="20px"
            id="copy_link_button"
          >
            {t('PartnerpluginsdkActivate.copyLink')}
          </StyledButton1>
        </StyledButtonContainer>
      </Center>
    </Container>
  );
};

export default DescriptionWithBrowserNotSupported;
